export const SLIDER_TYPE = "SLIDER";
export const BLOCK_TYPE = "BLOCK";
export const REGISTER = "REGISTER";
export const MODIFY = "MODIFY";
export const CANCEL = "CANCEL";
export const GENERAL = "GENERAL";
export const OPEN_ROOM = "OPEN_ROOM";
export const SUCCESS = "SUCCESS";
